import { Component, ElementRef, inject, input, model, OnInit, ViewChild } from '@angular/core';
import * as uuid from 'uuid';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ButtonTypes } from '@core/enums/button-types';
import { NgForm } from '@angular/forms';

export class ButtonOptions {
  id?: string = uuid.v4();
  class?: string;
  hostClass?: string;
  text?: string;
  type?: ButtonTypes;
  icon?: string;
  onClick?: (args?: any) => any;
  tooltip?: string;
  disabled?: boolean;
  formId?: string;
  isLoading?: boolean;

  constructor(args?: ButtonOptions) {
    this.id = args?.id || uuid.v4();
    this.class = args?.class || 'btn';
    this.hostClass = args?.hostClass || '';
    this.text = args?.text;
    this.type = args?.type || ButtonTypes.button;
    this.icon = args?.icon;
    this.onClick = args?.onClick;
    this.tooltip = args?.tooltip;
    this.disabled = args?.disabled && true;
    this.formId = args?.formId;
    this.isLoading = args?.isLoading && true;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-button',
  imports: [NgbTooltip],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: {
    '(click)': 'options().hostClass ? onClick($event) : doNothing($event)',
    '(focus)': 'focus()',
  },
})
export class ButtonComponent implements OnInit {
  @ViewChild('btn') public btn!: ElementRef<HTMLButtonElement>;
  private readonly translate = inject(TranslateService);
  private elementRef = inject(ElementRef);
  protected translations = this.translate.instant('button');

  options = model<ButtonOptions>(new ButtonOptions());

  ngOnInit() {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('button');
    });
    if (this.options().hostClass) {
      this.elementRef.nativeElement.setAttribute('class', this.options()?.hostClass);
    }
  }

  protected onClick = (event: PointerEvent) => {
    if (!this.options().isLoading && this.options().onClick) {
      this.options()?.onClick?.(event);
    }
  };

  protected doNothing = (event: PointerEvent) => {
    return;
  };

  blur() {
    this.btn.nativeElement.blur();
  }

  focus() {
    this.btn.nativeElement.focus();
  }
}
